import script from './option-group.vue_vue_type_script_lang.mjs';
export { default } from './option-group.vue_vue_type_script_lang.mjs';
import { render } from './option-group.vue_vue_type_template_id_072bbb70_lang.mjs';

script.render = render;
script.__file = "packages/components/select/src/option-group.vue";
//# sourceMappingURL=option-group.mjs.map
